module.exports = __webpack_public_path__ + "img/developer-part2-2.aab81236.png";